"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YesOrNoNum = void 0;
var YesOrNoNum;
(function (YesOrNoNum) {
  YesOrNoNum[YesOrNoNum["Yes"] = 1] = "Yes";
  YesOrNoNum[YesOrNoNum["No"] = 0] = "No";
})(YesOrNoNum || (exports.YesOrNoNum = YesOrNoNum = {}));